var _circle, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgSuccessNotification = function SvgSuccessNotification(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.12,
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#27AE60"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.761 16.49a1.176 1.176 0 0 0-.761-.261 1.17 1.17 0 0 0-.753.282.98.98 0 0 0-.34.674.959.959 0 0 0 .252.705l2.47 2.366c.104.1.228.178.366.232a1.207 1.207 0 0 0 1.237-.222l7.547-7.107c.102-.096.182-.21.237-.334a.942.942 0 0 0-.012-.78 1.024 1.024 0 0 0-.248-.328 1.133 1.133 0 0 0-.366-.217 1.212 1.212 0 0 0-.855.011c-.135.053-.257.13-.36.226l-6.733 6.356-1.68-1.604Z",
    fill: "#27AE60"
  })));
};

export default SvgSuccessNotification;